import React, {useState} from "react";
// import { faker } from '@faker-js/faker';
import {Collapse, Row, Col, Button, ProgressBar} from "react-bootstrap";
import {Link} from "react-router-dom";

const CollapsibleCompanyItem = ({company}) => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const getTextColorByNumber = (number) => {
    const parsedNumber = parseFloat(number); // Convert to a floating-point number
    if (!isNaN(parsedNumber)) {
      return parsedNumber < 0 ? "text-danger" : "text-success";
    } else {
      // Handle NaN case
      return "text-warning"; // Or any other color for NaN
    }
  };

  // // const history = useHistory();
  // const handleBrokerClick = () => {
  //   history.push("/brokers");
  // };

  const items = (
    <Row>
      <Col
        sm={12}
        lg={1}
        className="d-flex justify-content-between m-auto mb-3 mb-lg-auto"
      >
        <span className="d-lg-none">Market Value</span>
        <span>{company.presentValue}</span>
      </Col>
      <Col
        sm={12}
        lg={1}
        className="d-flex justify-content-between m-auto mb-3 mb-lg-auto"
      >
        <span className="d-lg-none">InvestedValue</span>
        <span>{company.investedValue}</span>
      </Col>
      <Col
        sm={12}
        lg={1}
        className="d-flex justify-content-between m-auto mb-3 mb-lg-auto"
      >
        <span className="d-lg-none">Quantity</span>
        <span className={getTextColorByNumber(company.qtyBought)}>
          {company.qtyBought}
        </span>
      </Col>
      <Col
        sm={12}
        lg={1}
        className="d-flex justify-content-between m-auto mb-3 mb-lg-auto"
      >
        <span className="d-lg-none">Quantity Left</span>
        <span className={getTextColorByNumber(company.qtyLeftover)}>
          {company.qtyLeftover}
        </span>
      </Col>
      <Col
        sm={12}
        lg={1}
        className="d-flex justify-content-between m-auto mb-3 mb-lg-auto"
      >
        <span className="d-lg-none">Purchase Price</span>
        <span>{company.purchasePrice}</span>
      </Col>
      <Col
        sm={12}
        lg={1}
        className="d-flex justify-content-between m-auto mb-3 mb-lg-auto"
      >
        <span className="d-lg-none">PL Net</span>
        <span className={getTextColorByNumber(company.netPL)}>
          {company.netPL}
        </span>
      </Col>
      <Col className="" sm={12} lg={1}>
        <a className="interaction-button d-flex d-lg-none" href="/brokers">
          {company.broker} <i className="bi bi-chevron-right ms-auto"></i>
        </a>
        <Link to="/brokers" className="interaction-link d-none d-lg-flex">
          {company.broker}
        </Link>
      </Col>
      {/*<Col className="" sm={12} lg={2}>*/}
      {/*  <a className="interaction-link d-none d-lg-flex">Broker</a>*/}
      {/*  <Button*/}
      {/*    className="interaction-button d-flex d-lg-none"*/}
      {/*    onClick={handleBrokerClick}*/}
      {/*  >*/}
      {/*    Interactive Brokers <i className="bi bi-chevron-right ms-auto"></i>*/}
      {/*  </Button>*/}
      {/*</Col>*/}
    </Row>
  );

  return (
    <Row className="d-block d-lg-flex">
      <Col sm={12} lg={3} className="d-flex">
        <div>{company.logo}</div>
        <div className="ps-3 ps-lg-4 d-grid">
          <span style={{textWrap: "no-wrap"}}>{company.ticker}</span>
          <small className="text-secondary mt-2">{company.legalName}</small>
        </div>
        <Button
          variant="link"
          onClick={toggleCollapse}
          aria-expanded={collapsed}
          className="mb-3 text-white ms-auto d-lg-none"
        >
          <i className={"bi bi-chevron-" + (collapsed ? "up" : "down")}></i>
        </Button>
      </Col>

      <Col sm={12} lg={8} className="d-none d-lg-block align-items-center">
        {items}
      </Col>

      <Col sm={12} className="d-block">
        <ProgressBar
          className="progress-sm mt-3 mt-lg-4"
          now={company.progressBar}
        />
      </Col>

      <Col sm={12} className="d-lg-none">
        <Collapse in={collapsed} className="mt-3 mt-lg-auto ">
          {items}
        </Collapse>
      </Col>
    </Row>
  );
};

export default CollapsibleCompanyItem;
